<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          label="Buscar..."
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col align="end">
        <v-btn rounded color="primary" @click="showNewRawMaterialModal = true">
          <v-icon>mdi-plus</v-icon>
          Agregar registro
        </v-btn>
        <v-btn rounded color="primary" @click="fetchData()" class="ml-2">
          <v-icon>mdi-refresh</v-icon>
          Recargar
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-data-table
          fixed-header
          height="450px"
          :headers="headers"
          :items="rawMaterial"
          :items-per-page="10"
          no-data-text="No hay materia prima"
          loading-text="Cargando materia prima..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          @click:row="rowSelect"
          :item-class="row_classes"
        >
          <template #[`item._id`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="openDetailMaterial(item)"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-file-document-edit-outline
                </v-icon>
              </template>
              <span>Validaciones</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="openUpdateMaterial(item)"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>
          </template>
          <template #[`item.status`]="{ item }">
            <span class="text-caption">
              {{ getStatus(item.status) }} - validación
              {{ item.numValidation }}
            </span>
          </template>
          <template #[`item.quantity`]="{ item }">
            <span> {{ item.quantity }} {{ item.unit.text }} </span>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
        ></v-pagination>
      </v-col>
    </v-row>
    <NewRawMaterialModal
      v-model="showNewRawMaterialModal"
      v-if="showNewRawMaterialModal"
      @confirmation="fetchData()"
    />
    <ValidationsModal
      v-model="showValidationsModal"
      v-if="showValidationsModal"
    />
  </v-container>
</template>

<script>
// components
import NewRawMaterialModal from "@/components/quality/modals/NewRawMaterialModal.vue";
import ValidationsModal from "@/components/quality/modals/ValidationsModal.vue";

// vuex
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {
    NewRawMaterialModal,
    ValidationsModal,
  },
  data: () => ({
    search: null,
    headers: [
      { text: "ID", align: "center", value: "serial", sortable: false },
      {
        text: "Estatus",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Fecha de arribo al almacén",
        align: "center",
        value: "arrivalDate",
        sortable: false,
      },

      {
        text: "Materia prima",
        align: "center",
        value: "type",
        sortable: false,
      },
      {
        text: "Cantidad (Kg o L)",
        align: "center",
        value: "quantity",
        sortable: false,
      },
      // { text: "Anexo", align: "center", value: "annex", sortable: false },
      { text: "Acciones", align: "center", value: "_id", sortable: false },
    ],
    rawMaterial: [],
    page: 1,
    numPages: 1,
    fetchingData: false,
    showNewRawMaterialModal: false,
    showValidationsModal: false,
  }),
  async mounted() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("material", ["getMaterials"]),
    ...mapMutations("material", ["SET_RAW_MATERIAL"]),
    rowSelect(rowValue) {
      this.rawMaterial = this.rawMaterial.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getMaterials({
          page: this.page,
          search: this.search,
        });
        if (response) {
          if (!response.error) {
            this.rawMaterial = response.materials;
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar materia prima`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar materia prima`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar materia prima`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    openDetailMaterial(item) {
      this.SET_RAW_MATERIAL(item);
      this.showValidationsModal = true;
    },
    getStatus(currentStatus) {
      let status = {
        DISCARD: "Descartado",
        NOT_STARTED: "No iniciado",
        OR: "Características organolépticas",
        MB: "Análisis microbiológicos",
        PCT: "Análisis Fisicoquímicos",
        MP: "Conformidad y Aceptación de MP",
        END: "Finalizado",
      };
      return status[currentStatus];
    },
    openUpdateMaterial(item) {
      this.SET_RAW_MATERIAL(item);
      this.showNewRawMaterialModal = true;
    },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      await this.fetchData();
    },
  },
};
</script>
